<template>
  <v-container fluid>
    <v-row class="d-flex align-center justify-center mb-1 mt-3">
      <v-img max-height="28px" contain src="https://swiset.com/wp-content/uploads/2018/07/Swiset_Imagotipo_RGB_Black.png"/>
    </v-row>
    <CollapsedRegister/>
    <v-row class="pa-3" style="background-color: #EEEEEE" align="center" justify="center">
      <p class="my-0">{{ $t('phrase') }}</p>
    </v-row>
  </v-container>
</template>

<script>
import CollapsedRegister from "@/components/CollapsedRegister";
export default {
  name: "Home",
  components: {CollapsedRegister},
  methods: {
  }
}
</script>

<i18n>
{
  "en": {
    "phrase": "Helping traders to get more targets"
  },
  "es": {
    "phrase": "Ayudando traders a alcanzar más targets"
  }
}
</i18n>

<style scoped>

</style>
